<template>
  <div class="flex justify-center" style="max-width: 1200px; margin: auto;">
    <div
      class="code-type-selector-container text-center text-xs flex flex-col items-center"
    >
      <div class="mb-2">Select Question Type</div>
      <div
        class="bg-grey-lighter p-2 flex flex-col items-center"
        style="width:5rem;"
      >
        <button
          class="hover:bg-grey rounded-sm flex flex-col text-grey-darker items-center justify-center m-0 mb-2 py-1 px-4"
          :class="questionType == 6 ? 'selected-type' : ''"
          title="Code"
          @click="getQuestions(6)"
        >
          <i class="material-icons cursor-pointer">code</i>
          Code
        </button>
        <button
          class="hover:bg-grey rounded-sm flex flex-col text-grey-darker items-center justify-center m-0 mb-2 py-1 px-4"
          :class="questionType == 9 ? 'selected-type' : ''"
          title="Web"
          @click="getQuestions(9)"
        >
          <i class="material-icons cursor-pointer ">web</i>
          Web
        </button>
        <button
          class="hover:bg-grey rounded-sm flex flex-col text-grey-darker items-center justify-center m-0 mb-2 py-1 px-4"
          :class="questionType == 8 ? 'selected-type' : ''"
          title="Blockly"
          @click="getQuestions(8)"
        >
          <i class="material-icons cursor-pointer">casino</i>
          Blockly
        </button>
        <button
          class="hover:bg-grey rounded-sm flex flex-col text-grey-darker items-center justify-center m-0 py-1 px-4"
          :class="questionType == 0 ? 'selected-type' : ''"
          title="MCQ"
          @click="getQuestions(0)"
        >
          <i class="material-icons cursor-pointer">question_answer</i>
          MCQ
        </button>
      </div>
    </div>
    <div class="ml-4">
      <!-- head -->
      <div class="">
        <div class="flex justify-between items-center">
          <h2>Create Assessment</h2>
          <div>
            <button
              class="mr-2 button-green rounded py-2 px-4 text-white"
              :style="`cursor: ${disableSave ? 'not-allowed' : 'pointer'}`"
              @click="addAssignment"
            >
              Save Assessment
            </button>
            <button
              class="button-blue rounded py-2 px-4 text-white"
              @click="duplicateAssessment"
            >
              Duplicate Assessment
            </button>
          </div>
        </div>
      </div>
      <div class="assessment-details mt-12">
        <div class="wrapper-flex-center">
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Type</div>
              <select v-model="assignment.assessment_type" style="width:90%">
                <option
                  v-for="(type, i) in assignmentTypeChoices"
                  :key="i"
                  :value="type"
                  >{{ type }}</option
                >
              </select>
            </div>
          </div>

          <div
            v-if="assignment.assessment_type === 'contest'"
            class="input-wrapper-container w-1/3"
          >
            <div class="input-wrapper-2">
              <div class="input-label-2">Custom Form</div>
              <select
                v-model="assignment.user_forms.contest_popup"
                style="width:90%"
              >
                <option value="null">none</option>
                <option
                  v-for="(type, i) in contestFormKeyOptions"
                  :key="i"
                  :value="type"
                  :selected="assignment.user_forms.contest_popup === type"
                  >{{ type }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <hr class="horizontal-divider" />

        <div class="wrapper-flex-center">
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Name</div>
              <input v-model="assignment.name" type="text" />
            </div>
          </div>

          <!-- Only when editing assessment -->

          <div
            v-if="this.$route.params.assessment_id"
            class="input-wrapper-container w-1/3"
          >
            <div class="input-wrapper-2">
              <div class="input-label-2">Slug</div>
              <input v-model="slug" type="text" readonly disabled />
            </div>
          </div>
        </div>
        <hr class="horizontal-divider" />

        <div class="wrapper-flex-center">
          <div class="input-wrapper-2 w-full">
            <div class="input-label-2">Add Company</div>
            <VueSelect
              v-model="assignment.assigned_companies"
              :options="companyOptions"
              label="name"
              multiple
              :closeOnSelect="false"
            />
          </div>
        </div>

        <div class="wrapper-flex-center">
          <div class="input-wrapper-2 w-full">
            <div class="input-label-2">Add Proficiency Level</div>
            <VueSelect
              v-model="assignment.proficiency_level"
              :options="questionProficiencyOptions"
            />
          </div>
        </div>

        <div class="wrapper-flex-center">
          <div class="input-wrapper-2 w-full">
            <div class="input-label-2">Question Bank Tags</div>
            <VueSelect
              v-model="assignment.question_bank_tags"
              :options="questionBankTagOptions"
              label="name"
              multiple
              :closeOnSelect="false"
            />
          </div>
        </div>
        <div class="wrapper-flex-center">
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Minimum Time away</div>
              <input
                v-model="assignment.schedule.min_time_away_secs"
                type="number"
              />
            </div>
          </div>

          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Max Time away</div>
              <input
                v-model="assignment.schedule.max_time_away_secs"
                type="number"
              />
            </div>
          </div>
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Reschedule Min Time</div>
              <input
                v-model="assignment.schedule.reschedule_min_time_away_secs"
                type="number"
              />
            </div>
          </div>
        </div>
        <hr class="horizontal-divider" />

        <div class="wrapper-flex-center">
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Maximum Reschedules</div>
              <input value="0" type="number" />
            </div>
          </div>
          <div class="input-wrapper-container w-1/3">
            <div class="input-wrapper-2">
              <div class="input-label-2">Maximum Attempts</div>
              <input v-model="assignment.max_attempts" type="number" />
            </div>
          </div>
        </div>
        <hr class="horizontal-divider" />
        <div class="wrapper-flex-center mb-10">
          <div class="relative mr-4 ">
            <div class="input-wrapper-2">
              <input v-model="assignment.show_results" type="checkbox" />
              <span class="input-label-3">Show Results</span>
            </div>
          </div>
          <div class="relative mr-4">
            <div class="input-wrapper-2">
              <input v-model="assignment.video_proctored" type="checkbox" />
              <span class="input-label-3">Video Proctored</span>
            </div>
          </div>
          <div class="relative mr-4">
            <div class="input-wrapper-2">
              <input v-model="assignment.monitor_violations" type="checkbox" />
              <span class="input-label-3">Monitor Violations</span>
            </div>
          </div>
        </div>
        <hr class="horizontal-divider" />

        <div class="w-full">
          <div>
            <div
              v-for="(section, iSection) in assignment.sections"
              :key="iSection"
              class="sections-container rounded-lg relative shadow"
            >
              <div class="ml-6 mt-1 flex items-center justify-between">
                <h3 class="">Section #{{ iSection + 1 }}</h3>
                <div class="flex ">
                  <span class="mr-2 flex justify-center items-center">
                    <i class=" underline font-extrabold mr-2">Name: </i>
                    <input
                      v-model="section.name"
                      style="all: unset; width: 50%;"
                    />
                  </span>
                  <span class="flex justify-center items-center">
                    <i class=" underline font-extrabold mr-2">Time: </i>
                    <input
                      v-model="section.time_limit_secs"
                      style="all: unset; width: 25%;"
                    />
                  </span>
                  <span class="flex justify-center items-center">
                    <i class=" underline font-extrabold mr-2">Cutoff: </i>
                    <input
                      v-model="section.score_cutoff_percent"
                      style="all: unset; width: 25%;"
                    />
                  </span>
                </div>
                <h3 class="mr-20">
                  #Questions {{ section ? section.questions.length : 0 }}
                </h3>
              </div>
              <img
                class="absolute cursor-pointer toggle-section toggle-section-btn-off"
                style=" top: 12px;left: 8px; width: 20px; height: 20px;"
                src="/images/arrow.png"
              />
              <img
                class="absolute cursor-pointer"
                style=" top:10px;right: 5px; width: 25px; height: 25px;"
                src="/images/trash.png"
                @click="removeSection(iSection)"
              />
              <!--  -->
              <div class="row px-3">
                <!--  -->
                <div class="wrapper-flex-center mt-10">
                  <div class="input-wrapper-container w-1/2">
                    <div class="input-wrapper-2">
                      <div class="input-label-2">Name</div>
                      <input v-model="section.name" type="text" />
                    </div>
                  </div>
                  <!--  -->
                  <div class="input-wrapper-container w-1/3">
                    <div class="input-wrapper-2">
                      <div class="input-label-2">Time Limit (secs)</div>
                      <input v-model="section.time_limit_secs" type="text" />
                    </div>
                  </div>
                  <!--  -->
                  <div class="input-wrapper-container w-1/3">
                    <div class="input-wrapper-2">
                      <div class="input-label-2">
                        Score Cutoff percentage (0.0 - 1.0)
                      </div>
                      <input
                        v-model="section.score_cutoff_percent"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <!--  -->
                <div class="w-full mt-3">
                  <h3>Questions</h3>
                  <div class="">
                    <div
                      v-for="(question, index) in section.questions"
                      :key="index"
                      class="tag-section-container rounded-lg shadow relative"
                    >
                      <img
                        class="absolute cursor-pointer"
                        style="right: -25px; width: 20px; height: 20px;"
                        src="/images/trash.png"
                        @click="removeQuestion(section, index)"
                      />
                      <div class="row">
                        <div class="row">
                          <!--  -->
                          <div class="wrapper-flex-center mt-5">
                            <!-- <div v-for="(candidate, cIndex) in question.candidates" :key="cIndex"> -->
                            <div class="input-wrapper-container w-4/5">
                              <div class="input-wrapper-2">
                                <div class="input-label-2">Questions</div>
                                <VueSelect
                                  v-model="question.candidates"
                                  label="name"
                                  multiple
                                  :closeOnSelect="false"
                                  :options="getQuestionOptions(questionOptions)"
                                  @input="handleQuestionSelection(question)"
                                />
                              </div>
                            </div>
                            <!--  -->

                            <div class="input-wrapper-container w-1/6 ml-3">
                              <div class="input-wrapper-2">
                                <div class="input-label-2">Count</div>
                                <input
                                  v-model="question.count"
                                  type="number"
                                  class="question-count"
                                />
                              </div>
                            </div>
                            <!--  -->

                            <!--  -->

                            <div class="input-wrapper-container w-1/5 mr-3">
                              <div class="input-wrapper-2">
                                <div class="input-label-2">Type</div>
                                <input
                                  v-model="question.question_type['name']"
                                  type="text"
                                  class="w-full"
                                  readonly
                                  disabled
                                />
                              </div>
                            </div>

                            <div class="input-wrapper-container w-1/5">
                              <div class="input-wrapper-2">
                                <div class="input-label-2">Max Score</div>
                                <input
                                  v-model="question.max_score"
                                  class="max-score"
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>

                          <!--  -->

                          <!--  -->
                          <div
                            v-if="getQuestionErrorMessages(question)"
                            class="mb-3"
                          >
                            <span style="color: red;">
                              <strong>Error Message:</strong>
                              {{ getQuestionErrorMessages(question) }}
                            </span>
                          </div>
                          <!--  -->
                          <!--  -->
                          <div class="w-full flex">
                            <div class="input-wrapper-2">
                              <input
                                v-model="question.is_required"
                                type="checkbox"
                              />
                              <span class="input-label-3">is_required</span>
                            </div>

                            <div class="input-wrapper-2">
                              <input
                                v-model="question.is_bonus"
                                type="checkbox"
                              />
                              <span class="input-label-3">is_bonus</span>
                            </div>

                            <!--  -->
                            <!--  -->

                            <div class="input-wrapper-2">
                              <input
                                v-model="question.show_evaluation_result"
                                type="checkbox"
                              />
                              <span class="input-label-3">
                                Show evaluation result
                              </span>
                            </div>

                            <!--  -->

                            <div class="input-wrapper-2">
                              <input
                                v-model="question.show_answer"
                                type="checkbox"
                              />
                              <span class="input-label-3">Show Answer</span>
                            </div>
                          </div>
                          <!--  -->

                          <!--  -->
                        </div>
                      </div>
                    </div>

                    <button
                      class="mt-2 rounded bg-grey-dark py-2 px-4 text-white"
                      @click="addQuestion(section)"
                    >
                      Add Question
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
          </div>
        </div>

        <div class="flex justify-between mt-10 mb-10">
          <button
            class="rounded bg-grey-dark py-2 px-4 text-white"
            @click="addSection"
          >
            Add Section
          </button>
          <button
            class="button-green rounded py-2 px-4 text-white"
            :style="`cursor: ${disableSave ? 'not-allowed' : 'pointer'}`"
            @click="addAssignment"
          >
            Save Assessment
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import { getCompanyList, getQbTags } from "@/apis/assesment"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      questionType: 6,
      questionOptions: [],
      questionTypeOptions: [
        {
          type: 0,
          name: "MCQ",
        },
        {
          type: 6,
          name: "Code",
        },
        {
          type: 8,
          name: "Blockly",
        },
        {
          type: 9,
          name: "Web",
        },
      ],
      contestFormKeyOptions: [],
      selectedQuestionToAddToSection: undefined,
      listOfQuestions: [],
      currentSelectedQuestionTypeOption: undefined,
      currentSelectedSection: undefined,
      assignmentTypeChoices: ["assignment", "contest"],
      slug: "",
      assignment: {
        name: "",
        assessment_type: "assignment",
        max_attempts: 5,
        can_transition: false,
        sections: [],
        schedule: {
          min_time_away_secs: 0,
          max_time_away_secs: 0,
          reschedule_min_time_away_secs: 0,
          total_time_limit_secs: 5,
        },
        show_results: false,
        video_proctored: false,
        monitor_violations: false,
        show_all_on_completion: false,
        user_forms: {
          contest_popup: null,
        },
        question_bank_tags: [],
        assigned_companies: [],
        proficiency_level: "",
      },
      questionProficiencyOptions: ["easy", "medium", "hard"],
      questionBankTagOptions: [],
      companyOptions: [],
    }
  },
  computed: {
    disableSave() {
      if (this.validateQuestionCountAndQuestionType) {
        return false
      }
      return true
    },
    validateQuestionCountAndQuestionType() {
      for (let i = 0; i < this.assignment.sections.length; i++) {
        const { questions } = this.assignment.sections[i]
        for (let j = 0; j < questions.length; j++) {
          if (this.getQuestionErrorMessages(questions[j])) {
            return false
          }
        }
      }
      return true
    },
  },
  mounted() {
    this.fetchQuestions()
    if (this.$route.params.assessment_id) {
      this.fetchAssignment()
    }
    this.getFormKeys()
    this.populateCompany()
    this.populateQuestionBankTags()
    document.addEventListener("click", this.sectionToggler)
  },
  beforeDestroy() {
    document.removeEventListener("click", this.sectionToggler)
  },
  methods: {
    getQuestions(type) {
      this.questionType = type
      this.fetchQuestions()
    },
    getQuestionErrorMessages(question) {
      if (question.candidates.length === 0) {
        return "Select the questions from dropdown"
      }

      const prev_candidate_question_type = question.candidates[0].type
      if (
        !question.candidates.every(
          item => item.type === prev_candidate_question_type
        )
      ) {
        return "Selected Questions are not the same type"
      }

      if (question.question_type.type !== prev_candidate_question_type) {
        return "The question Type is not matched with the selected questions, try to add again"
      }

      if (!question.count || parseInt(question.count) === 0) {
        return "Need to specify question count"
      }

      if (question.candidates.length < parseInt(question.count)) {
        return "Selected questions are less than the question count"
      }
      return ""
    },
    fetchQuestions() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/questions?pagination=false&search_by_type=${this.questionType}&fields=id,slug,name,reading_time,type,points,time_allocated,list`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.questionOptions = res.data.items
        })
        .catch(error => {
          this.$noty.error(`failed to fetch the questions ${error}`)
        })
    },
    sectionToggler(e) {
      if (e.target.classList.contains("toggle-section")) {
        const button = e.target
        const section = e.target.parentElement
        if (button.classList.contains("toggle-section-btn-off")) {
          button.classList.remove("toggle-section-btn-off")
          button.classList += " toggle-section-btn-on"
          section.style.height = "auto"
          section.style.overflow = "unset"
        } else {
          button.classList += " toggle-section-btn-off"
          button.classList.remove("toggle-section-btn-on")
          section.style.height = "50px"
          section.style.overflow = "hidden"
        }
      }
    },
    formatSource(data) {
      const temp = data.map((each, idx) => {
        const rec = {}
        rec.id = idx + 1
        rec.name = each.name
        rec.source = each
        return rec
      })
      return temp
    },
    populateCompany() {
      getCompanyList()
        .then(res => {
          this.companyOptions = res.data.items.map(item => ({
            id: item.id,
            name: item.name,
          }))
        })
        .catch(error => {
          this.$noty.error(`Failed to get the companies ${error}`)
        })
    },

    populateQuestionBankTags() {
      getQbTags()
        .then(res => {
          this.questionBankTagOptions = res.data.items.map(item => ({
            id: item.id,
            name: item.name,
          }))
        })
        .catch(error => {
          this.$noty.error(`Failed to get Question bank tags ${error}`)
        })
    },
    sanityChecks() {
      this.assignment.max_attempts = parseInt(this.assignment.max_attempts)
      this.assignment.schedule.min_time_away_secs = parseInt(
        this.assignment.schedule.min_time_away_secs
      )
      this.assignment.schedule.max_time_away_secs = parseInt(
        this.assignment.schedule.max_time_away_secs
      )
      this.assignment.schedule.reschedule_min_time_away_secs = parseInt(
        this.assignment.schedule.reschedule_min_time_away_secs
      )
      this.assignment.schedule.total_time_limit_secs = parseInt(
        this.assignment.schedule.total_time_limit_secs
      )

      for (let i = 0; i < this.assignment.sections.length; i++) {
        this.assignment.sections[i].time_limit_secs = parseInt(
          this.assignment.sections[i].time_limit_secs
        )
        this.assignment.sections[i].score_cutoff_percent = parseFloat(
          this.assignment.sections[i].score_cutoff_percent
        )

        for (let j = 0; j < this.assignment.sections[i].questions.length; j++) {
          // XXX: we were previously storing the entire tag object here, delete/cleanup if any!
          delete this.assignment.sections[i].questions[j].tag

          //
          this.assignment.sections[i].questions[j].count = parseInt(
            this.assignment.sections[i].questions[j].count
          )
          this.assignment.sections[i].questions[j].max_score = parseInt(
            this.assignment.sections[i].questions[j].max_score
          )
          /* if assessment is an assignment
          min_time_away_secs & max_time_away_secs can't be 0 or empty */
          if (
            this.assignment.assessment_type === "assignment" &&
            (!this.assignment.schedule.min_time_away_secs ||
              !this.assignment.schedule.max_time_away_secs)
          ) {
            this.$noty.error(
              "Minimum Time away & Max Time away should be positive time value as this is an user scheduled assignment. Please enter correct time in second and try again."
            )
            return false
          }
          if (this.assignment.sections[i].questions[j].count <= 0) {
            this.$noty.error(
              "Added a invalid question, please check and try to save again."
            )
            this.highlightError(".question-count")
            return false
          }
          if (this.assignment.sections[i].questions[j].max_score <= 0) {
            this.$noty.error(
              "Max score for one or more questions are 0, please check and try to save again."
            )
            this.highlightError(".max-score")
            return false
          }
        }
      }

      let total_time = 0
      for (let i = 0; i < this.assignment.sections.length; i++) {
        total_time += parseInt(this.assignment.sections[i].time_limit_secs)
      }
      this.assignment.schedule.total_time_limit_secs = total_time
      return true
    },
    highlightError(selector) {
      const domList = this.$el.querySelectorAll(selector)
      for (let i = 0; i < domList.length; i++) {
        if (domList[i].value <= 0) {
          domList[i].focus()
          domList[i].style.border = "2px solid red"
          setTimeout(() => {
            domList[i].style.border = "1px solid #c7c7c7"
          }, 4000)
          return
        }
      }
    },
    addAssignment() {
      if (this.disableSave) {
        alert("Save is disabled, please check section questions")
        return
      }
      const sanityCheckStatus = this.sanityChecks()
      if (!sanityCheckStatus) return

      const data = { ...this.assignment }

      let url
      let method
      if (this.$route.params.assessment_id) {
        url = `${siteConfig.siteURL}assignments/${this.$route.params.assessment_id}`
        method = "put"
      } else {
        url = `${siteConfig.siteURL}assignments/`
        method = "post"
      }

      this.axios({
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data,
      }).then(res => {
        this.$router.push("/assessmentlist")
        return res
      })
    },
    removeSection(i) {
      this.assignment.sections.splice(i, 1)
    },
    removeCodeTag(section, i) {
      section.question_code_tags.splice(i, 1)
    },
    removeQuestion(section, i) {
      section.questions.splice(i, 1)
    },
    addQuestion(section) {
      let lastQuestionObj = {
        is_required: true,
        is_bonus: false,
        show_evaluation_result: false,
        show_answer: false,
      }
      const totalQuestions = section.questions.length
      if (totalQuestions > 0) {
        lastQuestionObj = section.questions[totalQuestions - 1]
      }

      section.questions.push({
        candidates: [],
        count: 0,
        is_required: lastQuestionObj.is_required,
        is_bonus: lastQuestionObj.is_bonus,
        max_score: 0,
        show_evaluation_result: lastQuestionObj.show_evaluation_result,
        show_answer: lastQuestionObj.show_answer,
        question_type: this.questionTypeOptions[1],
      })
    },
    questionAddHandler(section) {
      this.currentSelectedSection = section
      this.$refs.questionmodal.open()
    },
    addSection() {
      this.assignment.sections.push({
        name: "",
        time_limit_secs: 10,
        can_transition: false,
        score_cutoff_percent: 0,
        is_score_visible: false,
        questions: [],
      })
    },
    fetchAssignment() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}assignments/${this.$route.params.assessment_id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.slug = res.data.slug
        const assignmentObj = {
          ...res.data.path,
        }
        this.assignment = assignmentObj
        window.pageTitle = `Edit - ${this.assignment.name}`
      })
    },
    getFormKeys() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}content`,
      })
        .then(res => {
          this.contestFormKeyOptions = res.data.filter(item =>
            item.startsWith("form-schema-")
          )
        })
        .catch(err => console.error("error fetching form keys", err))
    },
    getQuestionOptions(options) {
      const questions = options.map(question => {
        const elem = {}
        elem.id = question.id
        elem.name = question.name
        elem.type = question.type
        return elem
      })
      return questions
    },
    setSelectedQuestion(question) {
      return question.question_name
    },
    handleQuestionSelection(question) {
      question.question_type = this.questionTypeOptions.find(
        t => t.type === this.questionType
      )
    },
    duplicateAssessment() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/assessments/${this.$route.params.assessment_id}/duplicate`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          const id = res.data.duplicateAssessment
          this.$swal({
            text: `Duplicate assessment is created with this id: ${id}`,
            icon: "info",
            buttons: {
              Ok: true,
              confirm: {
                text: "Open in new tab",
                value: "confirm",
              },
            },
          }).then(value => {
            if (value === "confirm") {
              window.open(`/assessment/${id}`, "_blank")
            } else {
              this.$router.push("/assessmentlist")
              this.$noty.success("Assessment was duplicated")
            }
          })
        })
        .catch(error => {
          this.$noty.error(`failed to duplicate the assessment ${error}`)
        })
    },
  },
}
</script>

<style lang="postcss">
.tag-section-container {
  width: 98%;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: white;
}

.section-tags-container {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid black;
  background-color: rgba(0, 0, 0, 0.1);
}

.sections-container {
  overflow: hidden;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

.questions-container-assignment {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  background-color: white;
}

.wrapper-container {
  @apply w-full flex justify-center items-center mb-3;
}
.input-label {
  @apply w-1/4 text-right pr-2;
}
.input-wrapper {
  @apply w-3/4;
}

select {
  height: 34px;
}

input[type="checkbox"] {
  position: relative;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.wrapper-flex-center {
  @apply w-full flex items-center;
  margin-top: 35px;
}

.input-wrapper-container {
  @apply mb-5;
}

.input-wrapper-2 {
  @apply relative;
}
.input-label-2 {
  @apply text-right pr-2 absolute text-grey-darker;
  top: -20px;
}
.input-label-3 {
  @apply text-right pr-2 ml-2 text-grey-darker;
  right: 20px;
}
.toggle-section-btn-on {
  transition: all 200ms ease-in-out;
  transform: rotate(90deg);
}
.toggle-section-btn-off {
  transition: all 200ms ease-in-out;
  transform: rotate(-90 deg);
}
.horizontal-divider {
  border-top: 1px solid rgb(223, 223, 223);
}
.code-type-selector-container .selected-type {
  border: 1px solid #b3b3b3;
  background: #0000001a;
}
.code-type-selector-container {
  overflow: visible;
  position: sticky;
  top: 40%;
  left: 1rem;
  width: fit-content;
  height: 0;
  transform: translateY(-50%);
}
</style>
